import { Base } from './Base';
import { EdgeSlave } from '../Subscriptions/EdgeSlave';

export class Edge extends Base
{
	protected _subObjs={};

	public sendMasters(data, timeout=25000)
	{
		var reqObjs	= [];
		this.getMasters().forEach((subObj)=>{
			reqObjs.push(this.sendData(subObj, data, timeout));
		});
		return reqObjs;
	}
	public sendData(subObj, data, timeout=25000)
	{
		return subObj.tickTx().getRequest("data", data).setTimeout(timeout).exec();
	}
	public async handleIngress(reqObj)
	{
		try {
			
			var msgObj		= reqObj.getRxData();
			if (msgObj.type == "data") {
				
				var subObj		= this.getSubscriberBySyncId(msgObj.srcSync);
				if (typeof subObj == "object") {
					var evObj	= subObj.getEvent(reqObj);
					this.newEvent(evObj).then((rData)=>{
						reqObj.setTxData(rData);
					}, (errObj)=>{
						reqObj.setError(errObj);
					});
					
				} else {
					throw this.getAuto().newException("Not subscribed");
				}
				
			} else if (
				msgObj.type == "unsubscribe" 
				|| msgObj.type == "termination" //termination cannot provide authData
				|| msgObj.type == "disconnect"
			) {
				subObj		= this.getSubscriberBySyncId(msgObj.srcSync);
				if (typeof subObj == "object") {
					//this call does not expect a return
					//we remove first, since in every senario:
					//hijacked sync connection, unsubscription, termination, disconnect
					//there is nothing we can do to maintain the connection
					this.removeSubscriber(subObj);
					var evObj	= subObj.getEvent(reqObj);
					this.newEvent(evObj); //dont wait for a response
				}
				
			} else {
				throw this.getAuto().newException("Not handled for type: " + msgObj.type);
			}
		
		} catch (e) {
			reqObj.setError(e);
		}
	}
	public async subscribe(syncData, authData=null)
	{
		//we do not use peer ids on the edge
		if (
			typeof syncData == "object"
			&& typeof syncData["syncId"] == "string"
			&& typeof syncData["connId"] == "string"
		) {
			
			var subObj		= this.getSubscriberBySyncId(syncData.syncId);
			if (subObj === null) {
				//throws on peer not found
				var subObj		= new EdgeSlave();
				subObj.setAuto(this.getAuto()).setConfiguration(syncData.syncId, this);
				this._subObjs[syncData.syncId]	= subObj;
			}
			return subObj.connect(authData);
			
		} else {
			throw this.getAuto().newException("Invalid sync data");
		}
	}
	public getSubscriberBySyncId(syncId): EdgeSlave | null
	{
		if (typeof this._subObjs[syncId] != "undefined") {
			return this._subObjs[syncId];
		} else {
			return null;
		}
	}
	public getSubscribers()
	{
		return this._subObjs;
	}
	public getMasters()
	{
		var rObjs	= [];
		Object.keys(this._subObjs).forEach((guid)=>{
			var subObj	= this._subObjs[guid];
			if (subObj.getRole() == "slave") {
				rObjs.push(subObj);
			}
		});
		return rObjs;
	}
	public removeSubscriber(subObj)
	{
		if (typeof this._subObjs[subObj.getSyncId()] != "undefined") {
			delete this._subObjs[subObj.getSyncId()];
		}
		return this;
	}
	public terminate()
	{
		Object.keys(this._subObjs).forEach((guid)=>{
			var subObj	= this._subObjs[guid];
			subObj.terminate();
		});
		this.getParent().removeSync(this);
	}
}